import { Typography } from '@material-ui/core';
import React from 'react';
import useStyles from './styles'

const FooterTitle = ({title}) => {
    const classes = useStyles();
    return (
        <Typography variant='h3' className={classes.title}>
            {title}
        </Typography>
    )
}

export default FooterTitle
